/****************************************************
 * Module Name:  commissionProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class CommissionProxy {
  static GetAllCommission = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/user/broker/commission`,
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllCommissionHistory = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/user/broker/commission/payments`,
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdateCommissionPayment = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/user/broker/commission/payments`,
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllMixCommission = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/user/mix/broker/commission`,
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllMixCommissionHistory = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/user/mix/broker/commission/payments`,
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdateMixCommissionPayment = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/user/mix/broker/commission/payments`,
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };
}
